import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetMainConfig
 */
export default {
    /**
     * Return main config
     */
    apiGetMainConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/main_config`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * @param {String} code
     */
    submitCodeFlag1: function (code) {
        const token = Account.getToken();
        const params = {
            code: code,
        };

        const url = ConfigManager.getApiModuleUrl() + "/code";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

};
